import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { Loader } from '@/shared'
import { routes } from '@Config/config'

import { addInsuredData } from '../../helper'
import { GoBack } from '../GoBack/GoBack'

import { Data } from './Data/Data'
import style from './Insured.module.scss'

interface IProps {
    type: string
}

export const Insured = observer((props: IProps) => {
    const { type } = props
    const { insuredId } = useParams()
    const navi = useNavigate()

    useEffect(() => {
        if (type === 'add' && !dmsState.chosenInsured) {
            dmsState.onSetChosenInsured({ add: addInsuredData })
        }
    }, [type])

    useEffect(() => {
        if (type === 'edit' && insuredId && !dmsState.chosenInsured) {
            dmsState.onGetChosenInsured(insuredId)
        }
        return () => {
            dmsState.onSetChosenInsured(null)
        }
    }, [insuredId, type])

    if (!dmsState.chosenInsured || !dmsState.companiesList) {
        return <Loader />
    }

    const onHandleGoBack = () => navi(`${routes.DMSM}/insureds`)

    return (
        <>
            <GoBack onGoBack={onHandleGoBack} />
            <div className={style.container}>
                <Data />
            </div>
        </>
    )
})
